var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTitle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2113,
    height: 545,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-82 -73)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 118.296 1.06932",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 570.5 217.569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.5 210.5 760.362 231.856",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.5 150.5 691.9 173.913",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.5 198.5C667.5 177.513 684.513 160.5 705.5 160.5 726.487 160.5 743.5 177.513 743.5 198.5 743.5 219.487 726.487 236.5 705.5 236.5 684.513 236.5 667.5 219.487 667.5 198.5Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 695.747 210)"
  }, "C"), /*#__PURE__*/React.createElement("path", {
    d: "M719.5 170C719.5 161.439 726.44 154.5 735 154.5 743.56 154.5 750.5 161.439 750.5 170 750.5 178.56 743.56 185.5 735 185.5 726.44 185.5 719.5 178.56 719.5 170Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFC000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 724.095 181)"
  }, "H"), /*#__PURE__*/React.createElement("path", {
    d: "M654.5 138C654.5 129.44 661.216 122.5 669.5 122.5 677.784 122.5 684.5 129.44 684.5 138 684.5 146.561 677.784 153.5 669.5 153.5 661.216 153.5 654.5 146.561 654.5 138Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFC000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 658.314 149)"
  }, "H"), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 34.2866 27.7234",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 846.787 213.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.5 265C741.5 256.44 748.44 249.5 757 249.5 765.56 249.5 772.5 256.44 772.5 265 772.5 273.56 765.56 280.5 757 280.5 748.44 280.5 741.5 273.56 741.5 265Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFC000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 746.037 276)"
  }, "H"), /*#__PURE__*/React.createElement("path", {
    d: "M753.5 241.5C753.5 220.513 770.513 203.5 791.5 203.5 812.487 203.5 829.5 220.513 829.5 241.5 829.5 262.487 812.487 279.5 791.5 279.5 770.513 279.5 753.5 262.487 753.5 241.5Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 781.854 252)"
  }, "C"), /*#__PURE__*/React.createElement("path", {
    d: "M776.5 308C776.5 299.44 783.216 292.5 791.5 292.5 799.784 292.5 806.5 299.44 806.5 308 806.5 316.56 799.784 323.5 791.5 323.5 783.216 323.5 776.5 316.56 776.5 308Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFC000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 780.422 319)"
  }, "H"), /*#__PURE__*/React.createElement("path", {
    d: "M791.5 265.5 791.501 293.125",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.5 217.5 916.465 241.347",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.5 169.5 866.5 197.126",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.5 212.5C839.5 197.588 851.588 185.5 866.5 185.5 881.412 185.5 893.5 197.588 893.5 212.5 893.5 227.412 881.412 239.5 866.5 239.5 851.588 239.5 839.5 227.412 839.5 212.5Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#1F4E79",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 855.055 223)"
  }, "N"), /*#__PURE__*/React.createElement("path", {
    d: "M851.5 154.5C851.5 146.216 858.44 139.5 867 139.5 875.56 139.5 882.5 146.216 882.5 154.5 882.5 162.784 875.56 169.5 867 169.5 858.44 169.5 851.5 162.784 851.5 154.5Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFC000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 855.628 165)"
  }, "H"), /*#__PURE__*/React.createElement("path", {
    d: "M948.5 273.5 948.5 306.496",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.5 273.5 940.5 306.496",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 34.2869 27.7234",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 999.787 212.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.5 240C905.5 218.737 922.737 201.5 944 201.5 965.263 201.5 982.5 218.737 982.5 240 982.5 261.263 965.263 278.5 944 278.5 922.737 278.5 905.5 261.263 905.5 240Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 934.349 251)"
  }, "C"), /*#__PURE__*/React.createElement("path", {
    d: "M918.5 322C918.5 307.365 930.364 295.5 945 295.5 959.635 295.5 971.5 307.365 971.5 322 971.5 336.636 959.635 348.5 945 348.5 930.364 348.5 918.5 336.636 918.5 322Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#C00000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 933.019 333)"
  }, "O"), /*#__PURE__*/React.createElement("path", {
    d: "M1061.5 210.5 1087.36 231.856",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.5 150.5 1019.9 173.913",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.5 198.5C995.5 177.513 1012.51 160.5 1033.5 160.5 1054.49 160.5 1071.5 177.513 1071.5 198.5 1071.5 219.487 1054.49 236.5 1033.5 236.5 1012.51 236.5 995.5 219.487 995.5 198.5Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1023.58 210)"
  }, "C"), /*#__PURE__*/React.createElement("path", {
    d: "M1047.5 170C1047.5 161.439 1054.44 154.5 1063 154.5 1071.56 154.5 1078.5 161.439 1078.5 170 1078.5 178.56 1071.56 185.5 1063 185.5 1054.44 185.5 1047.5 178.56 1047.5 170Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFC000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1051.93 181)"
  }, "H"), /*#__PURE__*/React.createElement("path", {
    d: "M981.5 138C981.5 129.44 988.439 122.5 997 122.5 1005.56 122.5 1012.5 129.44 1012.5 138 1012.5 146.561 1005.56 153.5 997 153.5 988.439 153.5 981.5 146.561 981.5 138Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFC000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 986.145 149)"
  }, "H"), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 34.2866 27.7234",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 1173.79 215.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.5 267C1069.5 258.44 1076.22 251.5 1084.5 251.5 1092.78 251.5 1099.5 258.44 1099.5 267 1099.5 275.56 1092.78 282.5 1084.5 282.5 1076.22 282.5 1069.5 275.56 1069.5 267Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFC000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1073.45 278)"
  }, "H"), /*#__PURE__*/React.createElement("path", {
    d: "M1080.5 243C1080.5 221.737 1097.74 204.5 1119 204.5 1140.26 204.5 1157.5 221.737 1157.5 243 1157.5 264.263 1140.26 281.5 1119 281.5 1097.74 281.5 1080.5 264.263 1080.5 243Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1109.27 254)"
  }, "C"), /*#__PURE__*/React.createElement("path", {
    d: "M1103.5 310C1103.5 301.44 1110.44 294.5 1119 294.5 1127.56 294.5 1134.5 301.44 1134.5 310 1134.5 318.56 1127.56 325.5 1119 325.5 1110.44 325.5 1103.5 318.56 1103.5 310Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFC000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1107.84 321)"
  }, "H"), /*#__PURE__*/React.createElement("path", {
    d: "M1118.5 267.5 1118.5 295.125",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.5 207.5 1262.36 228.856",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.5 147.5 1194.9 170.913",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.5 196.5C1170.5 175.513 1187.51 158.5 1208.5 158.5 1229.49 158.5 1246.5 175.513 1246.5 196.5 1246.5 217.487 1229.49 234.5 1208.5 234.5 1187.51 234.5 1170.5 217.487 1170.5 196.5Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1198.58 207)"
  }, "C"), /*#__PURE__*/React.createElement("path", {
    d: "M1222.5 168C1222.5 159.44 1229.44 152.5 1238 152.5 1246.56 152.5 1253.5 159.44 1253.5 168 1253.5 176.561 1246.56 183.5 1238 183.5 1229.44 183.5 1222.5 176.561 1222.5 168Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFC000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1226.93 179)"
  }, "H"), /*#__PURE__*/React.createElement("path", {
    d: "M1156.5 135.5C1156.5 127.216 1163.44 120.5 1172 120.5 1180.56 120.5 1187.5 127.216 1187.5 135.5 1187.5 143.784 1180.56 150.5 1172 150.5 1163.44 150.5 1156.5 143.784 1156.5 135.5Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFC000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1161.15 147)"
  }, "H"), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 34.2866 27.7234",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 1349.79 213.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.5 264.5C1244.5 256.216 1251.22 249.5 1259.5 249.5 1267.78 249.5 1274.5 256.216 1274.5 264.5 1274.5 272.784 1267.78 279.5 1259.5 279.5 1251.22 279.5 1244.5 272.784 1244.5 264.5Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFC000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1248.46 276)"
  }, "H"), /*#__PURE__*/React.createElement("path", {
    d: "M1255.5 241C1255.5 219.737 1272.74 202.5 1294 202.5 1315.26 202.5 1332.5 219.737 1332.5 241 1332.5 262.263 1315.26 279.5 1294 279.5 1272.74 279.5 1255.5 262.263 1255.5 241Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1284.28 252)"
  }, "C"), /*#__PURE__*/React.createElement("path", {
    d: "M1278.5 307.5C1278.5 299.216 1285.44 292.5 1294 292.5 1302.56 292.5 1309.5 299.216 1309.5 307.5 1309.5 315.784 1302.56 322.5 1294 322.5 1285.44 322.5 1278.5 315.784 1278.5 307.5Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFC000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1282.84 319)"
  }, "H"), /*#__PURE__*/React.createElement("path", {
    d: "M1293.5 264.5 1293.5 292.125",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.5 167.496 1376.5 134.5",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.5 166.496 1384.5 133.5",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342.5 200C1342.5 178.737 1359.74 161.5 1381 161.5 1402.26 161.5 1419.5 178.737 1419.5 200 1419.5 221.263 1402.26 238.5 1381 238.5 1359.74 238.5 1342.5 221.263 1342.5 200Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1371.23 211)"
  }, "C"), /*#__PURE__*/React.createElement("path", {
    d: "M1406.5 118.5C1406.5 133.412 1394.64 145.5 1380 145.5 1365.36 145.5 1353.5 133.412 1353.5 118.5 1353.5 103.588 1365.36 91.4999 1380 91.4999 1394.64 91.4999 1406.5 103.588 1406.5 118.5Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#C00000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(-1 1.22465e-16 -1.22465e-16 -1 1390.9 106)"
  }, "O"), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 34.2866 27.7234",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 1517.79 201.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1455.47 228.347 1417.5 204.5",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1467.5 276.126 1467.5 248.5",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1493.5 233.5C1493.5 248.412 1481.64 260.5 1467 260.5 1452.36 260.5 1440.5 248.412 1440.5 233.5 1440.5 218.588 1452.36 206.5 1467 206.5 1481.64 206.5 1493.5 218.588 1493.5 233.5Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#1F4E79",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(-1 1.22465e-16 -1.22465e-16 -1 1477.7 221)"
  }, "N"), /*#__PURE__*/React.createElement("path", {
    d: "M1482.5 291C1482.5 299.56 1475.56 306.5 1467 306.5 1458.44 306.5 1451.5 299.56 1451.5 291 1451.5 282.439 1458.44 275.5 1467 275.5 1475.56 275.5 1482.5 282.439 1482.5 291Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFC000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(-1 1.22465e-16 -1.22465e-16 -1 1477.13 279)"
  }, "H"), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 76.1003 0.000360892",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 1574.5 201.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1517.5 143.5 1531.9 166.913",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.5 192.5C1507.5 171.513 1524.51 154.5 1545.5 154.5 1566.49 154.5 1583.5 171.513 1583.5 192.5 1583.5 213.487 1566.49 230.5 1545.5 230.5 1524.51 230.5 1507.5 213.487 1507.5 192.5Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1535.96 203)"
  }, "C"), /*#__PURE__*/React.createElement("path", {
    d: "M1560.5 164C1560.5 155.44 1567.22 148.5 1575.5 148.5 1583.78 148.5 1590.5 155.44 1590.5 164 1590.5 172.56 1583.78 179.5 1575.5 179.5 1567.22 179.5 1560.5 172.56 1560.5 164Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFC000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1564.31 175)"
  }, "H"), /*#__PURE__*/React.createElement("path", {
    d: "M1494.5 131.5C1494.5 123.216 1501.22 116.5 1509.5 116.5 1517.78 116.5 1524.5 123.216 1524.5 131.5 1524.5 139.784 1517.78 146.5 1509.5 146.5 1501.22 146.5 1494.5 139.784 1494.5 131.5Z",
    stroke: "#172C51",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFC000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 34,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1498.53 142)"
  }, "H"), /*#__PURE__*/React.createElement("path", {
    d: "M624.5 320.5C606.827 320.5 592.5 319.306 592.5 317.833L592.5 112.167C592.5 110.694 606.827 109.5 624.5 109.5",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1595.5 94.5C1613.73 94.5 1628.5 95.7312 1628.5 97.2499L1628.5 302.75C1628.5 304.269 1613.73 305.5 1595.5 305.5",
    stroke: "#000000",
    strokeWidth: 9.16667,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Rockwell,Rockwell_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 50,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1659.29 325)"
  }, "n"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Hiragino Sans W4,Hiragino Sans W4_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 147,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 227.073 494)"
  }, "Open Polymer Challenge")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle);
export default __webpack_public_path__ + "static/media/title.462758190a3cf384a510dd8918315d7f.svg";
export { ForwardRef as ReactComponent };